import MKTypography from "components/MKTypography";

export default function () {
    return (
        <MKTypography variant="h2">
            Under construction
        </MKTypography>
    )
}